import { useMemo } from 'react';
import { Dropdown, MenuProps } from 'antd';
import { ClbButton } from '@celebration/react/ClbButton/ClbButton';
import {
    SULAHUB_ROLES,
    SULAHUB_USERS_BY_USER_TYPE,
    SULAHUB_USERS_TYPES,
} from '../../../../../../common/constants/roles';
import './row-buttons.scss';
import { ITableRowButtons } from './ITableRowButtons';
import requestTableService from '../../services/requests-table.service';
import i18n from '../../../../../../lib/i18n';
import AuthContext from '../../../../../../app/contexts/auth';

function RequestsTableRowButtons({
    rowId,
    userTypeLabel,
    reproveUser,
    approveUser,
    userEmail,
}: Readonly<ITableRowButtons>) {
    const { isAuthorized } = AuthContext.useAuth();
    const btnEnabled = useMemo(
        () =>
            !isAuthorized([
                SULAHUB_ROLES.SYSTEM_PROFILES.SULA_USER,
                SULAHUB_ROLES.SYSTEM_PROFILES.MESA_PLUS_ADMIN,
                SULAHUB_ROLES.SYSTEM_PROFILES.TP_ADMIN_USER,
            ]),
        [isAuthorized],
    );

    const generateLabel = (
        id: string,
        label: string,
        userId: string,
        userType: number,
    ) => {
        return (
            // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
            <div
                data-testid={`aprove-button-${id}`}
                onClick={() => approveUser(userId, userType)}
            >
                {label}
            </div>
        );
    };

    const items: MenuProps['items'] = SULAHUB_USERS_TYPES.filter(
        type =>
            type.value !== SULAHUB_ROLES.SYSTEM_PROFILES.TP_ADMIN_USER &&
            type.value !== SULAHUB_ROLES.SYSTEM_PROFILES.TP_USER,
    ).map((user, index) => {
        const id = (index + 1).toString();
        return {
            key: id,
            label: generateLabel(
                id,
                user.label,
                rowId,
                SULAHUB_USERS_BY_USER_TYPE.find(
                    type => type.label === user.label,
                )!.value,
            ),
        };
    });

    const renderDropDownOnButton = (rowId: string) => {
        return (
            <Dropdown
                menu={{ items }}
                placement="bottom"
                trigger={['click']}
                disabled={btnEnabled}
            >
                <ClbButton
                    styleType="primary"
                    type="button"
                    size="sm"
                    data-testid={`aprove-button-row-${rowId}`}
                    label={i18n.t('AprovarUsuario')}
                    disabled={btnEnabled}
                />
            </Dropdown>
        );
    };

    const renderApproveButton = (rowId: string) => {
        return (
            <ClbButton
                styleType="primary"
                type="button"
                size="sm"
                data-testid={`aprove-button-row-${rowId}`}
                onClick={() => approveUser(rowId, undefined, userTypeLabel)}
                label={i18n.t('AprovarUsuario')}
                disabled={btnEnabled}
            />
        );
    };

    return (
        <div className="row-buttons">
            <ClbButton
                styleType="secondary"
                type="button"
                size="sm"
                data-testid={`reprove-button-row-${rowId}`}
                onClick={() => reproveUser(rowId)}
                label={i18n.t('ReprovarUsuario')}
                disabled={btnEnabled}
            />
            {!requestTableService.isAmbevUser(userEmail) &&
                renderApproveButton(rowId)}
            {requestTableService.isAmbevUser(userEmail) &&
                renderDropDownOnButton(rowId)}
        </div>
    );
}

export default RequestsTableRowButtons;
